import React from "react";
import { useDispatch } from "react-redux";
import RegularButton from "components/CustomButtons/Button";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { formatterNumberDecimals } from "helpers/mathDictionary";
import { openModal } from "redux/actions/supplyNotes/suplyNotesActions";

const INFO_COLOR = "#4092E5";

const selectColor = (status) => {
  switch (status) {
    case "Buena":
      return "#4caf50";
    case "Regular":
      return "#2c387e";
    case "Mala":
    case "Muy mala":
      return "#f6685e";
    default:
      return "";
  }
};

export const columns = [
  {
    Header: "Unidad",
    accessor: "unitName",
    filterable: true,
    filterMethod: (filter, row) => row.unitName?.toLowerCase().includes(filter.value.toLowerCase()),
  },
  {
    Header: "Nota",
    accessor: "folio",
    filterable: true,
    filterMethod: (filter, row) => row.folio?.toLowerCase().includes(filter.value.toLowerCase()),
  },
  {
    Header: "Cliente",
    accessor: "customer",
    filterable: true,
    filterMethod: (filter, row) => row.customer?.toLowerCase().includes(filter.value.toLowerCase()),
  },
  {
    Header: "Litros",
    accessor: "quantity",
    filterable: true,
    filterMethod: (filter, row) => row.quantity?.toLowerCase().includes(filter.value.toLowerCase()),
  },
  {
    Header: "Fecha inicio de servicio",
    accessor: "initialdate",
    filterable: true,
    filterMethod: (filter, row) => row.initialdate?.toLowerCase().includes(filter.value.toLowerCase()),
  },
  {
    Header: "Ubicación inicial",
    accessor: "initialLocation",
    filterable: true,
    filterMethod: (filter, row) => row.initialLocation?.toLowerCase().includes(filter.value.toLowerCase()),
  },
  {
    Header: "Fecha fin de servicio",
    accessor: "finalDate",
    filterable: true,
    filterMethod: (filter, row) => row.finalDate?.toLowerCase().includes(filter.value.toLowerCase()),
  },
  {
    Header: "Ubicación Final",
    accessor: "finalLocation",
    filterable: true,
    filterMethod: (filter, row) => row.finalLocation?.toLowerCase().includes(filter.value.toLowerCase()),
  },
  {
    Header: "Diferencia minutos",
    accessor: "minutesDiff",
    filterable: true,
    filterMethod: (filter, row) => row.minutesDiff?.toLowerCase().includes(filter.value.toLowerCase()),
  },
  {
    Header: "Diferencia metros",
    accessor: "distanceDiff",
    filterable: true,
    filterMethod: (filter, row) => row.distanceDiff?.toLowerCase().includes(filter.value.toLowerCase()),
    Cell: props => props.value != null ? formatterNumberDecimals(props.value, 2) : null,
  },
  {
    Header: "Estatus Metros",
    accessor: "status",
    filterable: true,
    filterMethod: (filter, row) => row.status?.toLowerCase().includes(filter.value.toLowerCase()),
    Cell: ({ original }) => (
      <p style={{ color: selectColor(original.status), fontWeight: 500 }}>
        {original.status}
      </p>
    ),
  },
  {
    Header: "Acciones",
    filterable: false,
    Cell: ({ original }) => {
      const dispatch = useDispatch();
      const handleNav = () => {
        dispatch(openModal(original));
      };
      return (
        <RegularButton
          color="transparent"
          round
          justIcon
          onClick={handleNav}
          tooltip="General"
          style={{ float: "right" }}
        >
          <VisibilityIcon style={{ margin: 0, color: INFO_COLOR }} />
        </RegularButton>
      );
    }
  }
];
